import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactLoading from 'react-loading'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import { CLAIM_DATA_URL, CLAIM_DETAIL_DATA_URL } from 'constants'

import About from './About'
import Workshop from './Workshop'
import Cost from './Cost'
import Driver from './Driver'
import Assistance from './Assistance'
import SMSSetup from './SMS'

import Button from 'components/Button'

import ClaimModal from 'modals/ClaimModal'

import { claimChanged } from 'scenes/VehicleDetail/actions'

import './styles.scss'


export class ClaimData extends BaseComponent {
  constructor(props) {
    super(props)

    this.state = {
      has_claim: null,
      claim: {}
    }

    this._bind('_openNewClaimModal', '_renderClaim')
  }

  componentDidMount() {
    const claimId = this.props.match.params.claimId
    const vehicleId = this.props.match.params.vehicleId
    if (claimId) {
      this._fetchSpecificClaim(vehicleId, claimId)
    }else{
      this._fetchClaim(vehicleId)
    }
  }

  _fetchSpecificClaim(vehicleId, claimId) {
    // console.log('will fetch specific claim ...')
    request(CLAIM_DETAIL_DATA_URL(vehicleId, claimId))
      .then(({claim}) => {
        this.props.claimChanged(claim)
        this.setState({
          has_claim: !!Object.keys(claim).length,
        })
      })
      .catch(console.log)
  }

  _fetchClaim(vehicleId) {
    request(CLAIM_DATA_URL(vehicleId))
      .then(({claim}) => {
        this.props.claimChanged(claim)
        this.setState({
          has_claim: !!Object.keys(claim).length,
        })
      })
      .catch(console.log)
  }

  _openNewClaimModal () {
    this.context.toggleModal(true,
      <ClaimModal />
    )
  }

  _renderClaim() {
    const claim = this.props.claim

    if(this.state.has_claim === null) {
      return (
        <div className="d-flex claimData">
          <ReactLoading id="Spin" type={'spin'} color={'#444'}  />
        </div>
      )
    } else {
      return this.state.has_claim ? (
        <div className="d-flex claimData">
          <div className="DetailClaimData__dropdowns">
            <About claim={claim} />
            <br></br>
            <Workshop workshop={claim.workshop}
                      claimId={claim.id}
                      vehicleId={this.props.match.params.vehicleId} />
          </div>
          <div className="DetailClaimData__leftcolumn">
            <Cost claim={claim} />
            <br></br>
            <Driver claim={claim} />
            <br></br>
            <Assistance claim={claim} />
            <br></br>
            <SMSSetup claim={claim} />
          </div>
        </div>
      ) : (
        <div className="no-claim">
          <h1>No hay ningún siniestro reportado</h1>
          <Button onClick={this._openNewClaimModal}>Iniciar Siniestro</Button>
        </div>
      )
    }
  }

  render() {
    return (
      <div id="DetailClaimData" className="DetailClaimData">
        { this._renderClaim() }
      </div>
    )
  }
}

ClaimData.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    claim: state.vehicleDetail.get('claim')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimData)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/index.js